import { Injectable, inject } from '@angular/core';
import { DataContextService, ResultWrapper } from '@seahorse/common';
import { ChatMessageModel, MessageModel } from './message.model';
import { Observable } from 'rxjs';
import { MessagesSearchModel } from './messages-search.model';

@Injectable({
  providedIn: 'root',
})
export class ChatMessagesService {
  private _dataContext = inject(DataContextService);

  searchWithContentMaps(
    search: MessagesSearchModel,
    pageIndex: number,
    pageSize: number
  ): Observable<ResultWrapper<MessageModel[]>> {
    return this._dataContext.post<MessageModel[]>(
      `messages/search/details?pindex=${pageIndex}&psize=${pageSize}`,
      search
    );
  }

  addMessage(
    message: ChatMessageModel
  ): Observable<ResultWrapper<MessageModel>> {
    return this._dataContext.post<MessageModel>('messages/chat', message);
  }
}
